<template>
  <div class="app-container pull-auto">
    <basic-container>
      <avue-crud
        ref="crud"
        :page="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        @current-change="currentChange"
        @size-change="sizeChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="rowDel"
      >
        <template slot="menuLeft">
          <el-button
            icon="el-icon-plus"
            type="primary"
            @click="handleAdd"
            size="small"
            v-if="permissions.tagtype_add"
          >新 增</el-button>
          <br />
          <br />
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="text"
            v-if="permissions.tagtype_edit"
            icon="el-icon-edit"
            size="mini"
            @click="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="text"
            v-if="permissions.tagtype_del"
            icon="el-icon-delete"
            size="mini"
            @click="handleDel(scope.row,scope.index)"
          >删除</el-button>
          <el-button
            type="text"
            v-if="permissions.tagtype_dict"
            icon="el-icon-menu"
            size="mini"
            @click="handleItem(scope.row,scope.index)"
          >字典项</el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog title="标签管理" :visible.sync="dialogFormVisible" width="70%" @close="cancelDialogForm">
      <avue-crud
        ref="crudItem"
        :page="pageItem"
        :data="tableDictItemData"
        @current-change="currentChangeItem"
        @size-change="sizeChangeItem"
        v-model="form"
        @row-update="handleItemUpdate"
        @row-save="handleItemSave"
        @row-del="rowItemDel"
        @search-change="searchChange"
        @search-reset="searchReset"
        @sort-change="handleSortChangeDictItem"
        :before-open="handleBeforeOpen"
        :option="tableDictItemOption"
        :table-loading="tagManagementTableLoading"
      >
        <template slot="sortForm">
          <el-input-number size="medium" v-model="form.sort" :precision="0" :step="1" :min="0" controls-position="right" @change="checkSortValue"></el-input-number>
        </template>
        <template slot="search">
          <el-form-item label="标签">
            <el-input v-model="keywords" size="small"></el-input>
          </el-form-item>
          <el-form-item label="编码">
            <el-input v-model="tagCode" size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select size="small" v-model="status">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="menuLeft">
          <el-button icon="el-icon-plus"
            type="primary"
            size="small"
            @click="handleDictAdd"
            v-if="permissions.tagtype_dict_add"
          >新增</el-button>
        </template>

        <template slot-scope="scope" slot="menu">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            @click="handleDictEdit(scope.row, scope.index, scope.done)"
            v-if="permissions.tagtype_dict_edit"
          >编辑</el-button>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-delete"
            @click="handleDictDel(scope.row, scope.index, scope.done)"
            v-if="permissions.tagtype_dict_del"
          >删除</el-button>
          <el-button
            type="text"
            v-if="permissions.tagtype_dict_unBanned && (scope.row.status === 2 )"
            size="mini"
            @click="handleApprove(scope.row,scope.index)"
          >启用</el-button>
          <el-button
            type="text"
            v-if="permissions.tagtype_dict_banned && (scope.row.status === 1 )"
            size="mini"
            @click="handleReject(scope.row,scope.index)"
          >禁用</el-button>
          <el-button type="text"
            size="mini"
            @click="handleRelate(scope.row,scope.index)"
            v-if="permissions.tagtype_dict_relatedTag"
          >关联标签</el-button>
        </template>
      </avue-crud>
    </el-dialog>

    <el-dialog
      title="关联标签"
      :visible.sync="dialogRelateFormVisible"
      width="70%"
      @close="cancelDialogRelateForm"
    >
      <avue-crud
        ref="crudTagRelation"
        @current-change="currentChangePageRelationItem"
        @size-change="sizeChangePageRelationItem"
        @search-reset="searchRelationReset"
        @search-change="searchRelateChange"
        @sort-change="handleSortChangeTagRelation"
        :page="pageRelationItem"
        :data="tableTagRelationData"
        :option="tableTagRelationOption"
        :table-loading="tagRelationTableLoading"
      >
        <template slot="menuLeft">
          <el-button icon="el-icon-plus"
            type="primary"
            size="small"
            @click="addRelatedTag"
            v-if="permissions.tagtype_dict_relatedTag_add"
          >新增</el-button>
        </template>
        <template slot="search">
          <el-form-item label="标签类型" label-width="300">
            <el-select v-model="searchRelateForm.tagTypeId" clearable placeholder="请选择标签类型">
              <el-option
                v-for="item in searchTagTypeList"
                :key="item.value"
                :label="item.tagTypeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签">
            <el-input v-model="relationKeywords"></el-input>
          </el-form-item>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            icon="el-icon-delete"
            type="text"
            size="mini"
            v-if="permissions.tagtype_dict_relatedTag_del"
            @click="handleRelateDelete(scope.row, scope.index)"
          >删除</el-button>
        </template>
      </avue-crud>
    </el-dialog>

    <el-dialog
      title="新增关联标签"
      :visible.sync="dialogAddRelateFormVisible"
      width="30%"
      @close="cancelDialog"
    >
      <el-form :model="newRelateFrom" label-position="top">
        <el-form-item label="标签类型" size="small">
          <el-select
            v-model="newRelateFrom.tagTypeId"
            placeholder="请选择标签类型"
            @change="tagTypeChange"
          >
            <el-option
              v-for="item in tagTypeList"
              :key="item.value"
              :label="item.tagTypeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签" size="small">
          <v-select
            class="vSelect"
            multiple
            label="name"
            v-model="selected"
            placeholder="请选择标签"
            :closeOnSelect="false"
            :resetOnOptionsChange="false"
            :filterable="false"
            :options="tagList"
            @search="search"
            :clearSearchOnBlur="clearSearchOnBlur"
            :selectable="option => selected.indexOf(option) === -1"
            ref="v-select"
          >
            <li slot="list-footer" class="pagination">
              <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="this.pageSelectItem.current"
                :page-size="this.pageSelectItem.size"
                :pager-count="6"
                :layout="pageLayout"
                :total="this.pageSelectItem.total"
              ></el-pagination>
            </div>
            </li>
            <template #open-indicator="{ attributes }">
              <i class="el-icon-arrow-down" v-bind="attributes"></i>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                没有搜索结果 <em>{{ search }}</em>
              </template>
              <em style="opacity: 0.5;" v-else>输入要搜索的标签</em>
            </template>
          </v-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="addRelationForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchList,
  getObj,
  addObj,
  putObj,
  delObj,
  fetchItemList,
  putItemObj,
  addNewTag,
  delItemObj,
  approveTag,
  rejectTag,
  searchRelatedTag,
  delRelateTagObj,
  fetchRelateItemList,
  getItemObjByType,
  addRelationTags,
} from '@/api/basic/tagtype';
import {
  tableOption,
  tableDictItemOption,
  statusOptions,
  tableTagRelationOption,
} from '@/const/crud/basic/tagtype';
import { mapGetters } from 'vuex';
import { VueSelect } from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { debounce } from 'lodash';

export default {
  name: 'tagtype',
  components: {
    'v-select': VueSelect,
  },
  data() {
    return {
      form: {},
      dictId: undefined,
      status: undefined,
      keywords: '',
      tagCode: '',
      relationKeywords: '',
      dialogFormVisible: false,
      tableData: [],
      tableDictItemData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageRelationItem: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageItem: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageSelectItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pages: 0,
      },
      listQuery: {
        current: 1,
        size: 10,
        status: '',
      },
      tableLoading: false,
      tagManagementTableLoading: false,
      tagRelationTableLoading: false,
      tableOption: tableOption,
      tableDictItemOption: tableDictItemOption,
      statusOptions: statusOptions,
      dialogRelateFormVisible: false,
      tableTagRelationData: [],
      tableTagRelationOption: tableTagRelationOption,
      dialogAddRelateFormVisible: false,
      tableAddTagRelationData: {},
      tagTypeList: [],
      searchTagTypeList: [],
      newRelateFrom: {},
      searchRelateForm: {},
      relatedTagIds: [],
      tagList: [],
      selected: [],
      searchSelect: '',
      pageLayout: 'total, prev, pager, next',
      pageRelationItemTagId: '',
      tagItemSort: [],
      tagRelationSort: []
    };
  },
  created() {
    this.getList();
  },
  mounted: function () {},
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    handleDictAdd() {
      this.$refs.crudItem.rowAdd();
    },
    handleDictEdit(row, index, done) {
      this.$refs.crudItem.rowEdit(row, index, done)
    },
    handleDictDel(row) {
      this.$refs.crudItem.rowDel(row)
    },
    getList() {
      this.tableLoading = true;
      fetchList(this.listQuery).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      });
    },

    getDictItemList(dictId) {
      this.dictId = dictId;
      this.dialogFormVisible = true;
      this.tagManagementTableLoading = true;
      fetchItemList(
        Object.assign(
          {
            current: this.pageItem.currentPage,
            size: this.pageItem.pageSize,
          },
          { type: dictId },
          { keywords: this.keywords },
          { status: this.status },
          { tagCode: this.tagCode },
          { sortField: this.tagItemSort.sortField },
          { sortPolicy: this.tagItemSort.sortPolicy },

        )
      ).then((response) => {
        this.tableDictItemData = this.formatData(response.data.data.records);
        this.pageItem.total = response.data.data.total;
        this.tagManagementTableLoading = false;
      });
    },

    getRelateItemList(tagId, typeId) {
      this.dialogRelateFormVisible = true;
      this.tagRelationTableLoading = true;
      fetchRelateItemList(
        {
          current: this.pageRelationItem.currentPage,
          size: this.pageRelationItem.pageSize,
          typeId: typeId,
          keywords: this.relationKeywords,
          sortField: this.tagRelationSort.sortField,
          sortPolicy: this.tagRelationSort.sortPolicy
        },
        tagId
      ).then((response) => {
        this.tableTagRelationData = response.data.data.records;
        this.pageRelationItem.total = response.data.data.total;
        this.tagRelationTableLoading = false;
      });
    },

    handleSortChangeDictItem(val) {
      // TODO 检查排序对象
      if (val.prop === "sort") {
        this.tagItemSort.sortField = "sort"
      } else {
        this.tagItemSort.sortField = ""
      }
      // 检查排序方式
      if (val.order === 'ascending') {
        this.tagItemSort.sortPolicy = "asc"
      } else if (val.order === 'descending') {
        this.tagItemSort.sortPolicy = "desc"
      } else {
        this.tagItemSort.sortPolicy = ""
      }
      this.getDictItemList(this.dictId);
    },

    handleSortChangeTagRelation(val) {
      if (val.prop === "sort") {
        this.tagRelationSort.sortField = "sort"
      } else {
        this.tagRelationSort.sortField = ""
      }
      // 检查排序方式
      if (val.order === 'ascending') {
        this.tagRelationSort.sortPolicy = "asc"
      } else if (val.order === 'descending') {
        this.tagRelationSort.sortPolicy = "desc"
      } else {
        this.seatagRelationSortrch.sortPolicy = ""
      }
      this.getRelateItemList(this.pageRelationItemTagId);
    },

    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach((x) => {
          x.statusText = this.statusOptions[x.status - 1].label;
        });
      }
      return records;
    },
    searchReset() {
      this.status = '';
      this.keywords = '';
      this.tagCode = '';
      this.searchChange();
    },
    searchChange() {
      this.pageItem.currentPage = 1;
      this.getDictItemList(this.dictId);
    },
    searchRelationReset() {
      this.relationKeywords = '';
      this.searchRelateForm.tagTypeId = '';
      this.searchRelateChange();
    },
    searchRelateChange(params) {
      this.pageRelationItem.currentPage = 1;
      this.getRelateItemList(
        this.newRelateFrom.tagId,
        this.searchRelateForm.tagTypeId
      );
    },
    handleApprove(row, index) {
      this.tagManagementTableLoading = true;
      this.$confirm('是否确认启用该标签?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return approveTag(row.id);
        })
        .then((response) => {
          this.$message({
            message: '启用成功',
            type: 'success',
          });
          if (response.data.data) {
            row.status = 1;
            row.statusText = this.statusOptions[row.status - 1].label;
          }
          this.tagManagementTableLoading = false;
        })
        .catch((error) => {
          this.tagManagementTableLoading = false;
        });
    },
    handleReject(row, index) {
      this.tagManagementTableLoading = true;
      this.$confirm('是否确认禁用该标签?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return rejectTag(row.id);
        })
        .then((response) => {
          this.$message({
            message: '禁用成功',
            type: 'success',
          });
          if (response.data.data) {
            row.status = 2;
            row.statusText = this.statusOptions[row.status - 1].label;
          }
          this.tagManagementTableLoading = false;
        })
        .catch((error) => {
          this.tagManagementTableLoading = false;
        });
    },
    currentChange(val) {
      this.page.current = val;
      this.listQuery.current = val;
      this.getList();
    },
    sizeChange(val) {
      this.page.size = val;
      this.listQuery.size = val;
      this.getList();
    },
    currentChangeItem(val) {
      this.pageItem.current = val;
      this.pageItem.currentPage = val;
      this.getDictItemList(this.dictId);
    },
    sizeChangeItem(val) {
      this.pageItem.size = val;
      this.pageItem.pageSize = val;
      this.getDictItemList(this.dictId);
    },
    currentChangePageRelationItem(val) {
      this.pageRelationItem.currentPage = val;
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    sizeChangePageRelationItem(val) {
      this.pageRelationItem.pageSize = val;
      this.getRelateItemList(this.pageRelationItemTagId);
    },

    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd: function () {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    handleDel(row, index) {
      this.$refs.crud.rowDel(row, index);
    },
    rowDel: function (row, index) {
      var _this = this;
      this.$confirm('是否确认删除ID为' + row.id + '的记录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.tableData.splice(index, 1);
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done) {
      putObj(row).then((data) => {
        this.tableData.splice(index, 1, Object.assign({}, row));
        this.$message({
          showClose: true,
          message: '修改成功',
          type: 'success',
        });
        done();
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done) {
      addObj(row).then((data) => {
        /** this.tableData.push(Object.assign({}, row))     **/
        this.getList();
        this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success',
        });
        done();
      });
    },
    /**
     * 加载 字典项
     * @param row
     */
    handleItem: function (row) {
      this.pageItem.currentPage = 1;
      this.status = '';
      this.getDictItemList(row.id);
    },
    handleItemSave: function (row, done) {
      row.type = this.dictId;
      row.status = 1;
      addNewTag(row)
        .then(() => {
          this.tableDictItemData.push(Object.assign({}, row));
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success',
          });
          this.getDictItemList(row.dictId);
          this.getList(this.page);
          done();
        })
        .catch((error) => {});
    },
    handleItemUpdate: function (row, index, done) {
      row.type = this.dictId;
      putItemObj(row)
        .then(() => {
          /** this.tableData.splice(index, 1, Object.assign({}, row)) */
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
          });
          this.getDictItemList(row.dictId);
          done();
        })
        .catch((error) => {});
    },
    handleBeforeOpen(done) {
      this.form.dictId = this.dictId;
      done();
    },

    rowItemDel: function (row) {
      var _this = this;
      this.$confirm('是否确认删除数据为"' + row.name + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delItemObj(row.id);
        })
        .then(() => {
          this.getDictItemList(this.dictId, row.type),
            _this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            });
        })
        .catch(function () {});
    },
    handleRelate(row, index) {
      this.pageItem.currentPage = 1;
      this.tagRelationTableLoading = true;
      this.dialogRelateFormVisible = true;
      this.getRelateItemList(row.id);
      this.newRelateFrom.tagId = row.id;
      this.pageRelationItemTagId = row.id;
      this.listTagType();
    },
    handleRelateDelete(row, index) {
      var _this = this;
      this.$confirm('是否确认删除数据为"' + row.name + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delRelateTagObj(row.relatedId);
        })
        .then(() => {
          this.getRelateItemList(row.tagId);
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
        })
        .catch(function () {});
    },
    // 新增关联标签
    addRelatedTag() {
      this.dialogAddRelateFormVisible = true;
      this.listTagType();
    },
    // 查找所有标签类型
    listTagType() {
      fetchList().then((res) => {
        const code = res.data.code;
        const data = res.data.data;
        if (code === 0 && data) {
          this.tagTypeList = data.records;
          this.searchTagTypeList = data.records;
        }
      });
    },
    tagTypeChange(typeId) {
      if (typeId != null) {
        this.newRelateFrom.tagTypeId = typeId;
        this.pageSelectItem.currentPage = 1;
        this.selected = [];
        this.tagList.search = '';
        this.handleCurrentChange(1);
      }
    },
    tagListSearch(search) {
      if (!this.newRelateFrom.tagTypeId) {
        return;
      }
      fetchItemList(
        Object.assign(
          {
            current: this.pageSelectItem.currentPage,
            size: this.pageSelectItem.size,
          },
          { type: this.newRelateFrom.tagTypeId },
          { keywords: search }
        )
      ).then((res) => {
        const code = res.data.code;
        const data = res.data.data;

        if (code === 0 && data) {
          this.tagList = data.records;
          this.pageSelectItem.pages = data.pages;
          this.pageSelectItem.total = data.total;
          if (this.pageSelectItem.total === 0) {
            this.pageLayout = 'total';
          } else {
            this.pageLayout = 'total, prev, pager, next';
          }
        }
      });
    },
    resultFormat(resp) {
      var gridResult = [];
      gridResult.list = resp.data.data.records;
      gridResult.totalRow = resp.data.data.total;
      return gridResult;
    },

    //批量添加关联标签
    addRelationForm() {
      const tagRelations = [];
      this.relatedTagIds = this.selected;
      this.relatedTagIds.forEach((item) => {
        tagRelations.push({
          tagId: this.newRelateFrom.tagId,
          relatedTagId: item.id,
        });
      });
      addRelationTags(tagRelations).then(() => {
        this.newRelateFrom.tagTypeId = '';
        this.pageSelectItem.currentPage = 1;
        this.selected = [];
        this.dialogAddRelateFormVisible = false;
        this.getRelateItemList(this.newRelateFrom.tagId);
      });
    },

    cancelDialog() {
      this.newRelateFrom.tagTypeId = '';
      this.selected = [];
      this.tagList = [];
      this.pageSelectItem.total = '';
      this.pageLayout = 'total';
      this.dialogAddRelateFormVisible = false;
    },

    cancelDialogForm() {
      this.keywords = '';
      this.dialogFormVisible = false;
    },

    cancelDialogRelateForm() {
      this.relationKeywords = '';
      this.searchRelateForm.tagTypeId = '';
      this.dialogRelateFormVisible = false;
    },

    handleCurrentChange(val) {
      this.pageSelectItem.currentPage = val
      fetchItemList(
        Object.assign(
          {
            current: this.pageSelectItem.currentPage,
            size: this.pageSelectItem.size,
          },
          { type: this.newRelateFrom.tagTypeId }
        )
      ).then((res) => {
        const code = res.data.code;
        const data = res.data.data;
        if (code === 0 && data) {
          this.tagList = data.records;
          this.pageSelectItem.pages = data.pages;
          this.pageSelectItem.total = data.total;
          if (this.pageSelectItem.total === 0) {
            this.pageLayout = 'total';
          } else {
            this.pageLayout = 'total, prev, pager, next';
          }
        }
      });
    },

    getTagList: debounce(function() {
      this.tagListSearch(this.searchSelect)}, 300),

    search(searchKeywords) {
      this.searchSelect = searchKeywords;
      this.getTagList();
    },

    clearSearchOnBlur() {
      return true;
    },

    checkSortValue() {
      if (this.form.sort > 10000) {
        this.$message({
          showClose: true,
          message: "最大值为10000",
          type: 'error'
        });
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
}
.pagination button:hover {
  cursor: pointer;
}
/deep/ .v-select.vSelect {
  .vs__dropdown-toggle {
    .vs__selected-options {
      input::placeholder {
        color: #c0c4cc;
        padding-left: 4px;
        font-size: inherit;
      }
    }
    .vs__actions {
      .el-icon-arrow-down {
        color: #c0c4cc;
      }
    }
  }
}
</style>
